// Copyright (c) 2026 WiseTime. All rights reserved.

import { isDevelopmentEnv } from "app/config"
import encodeLastPath from "../../lib/lastpath"

export const getBaseUrl = (): string =>
  isDevelopmentEnv() ? "https://wisetime.ninja" : ""

export const getLoginPath = (returnPath?: string): string => {
  const getCurrentPath = (): string => window.location.pathname
  const lastPath = returnPath || getCurrentPath()
  return `${getBaseUrl()}/customer/?lp=${encodeLastPath(lastPath)}`
}

export const getLogoutPath = (): string => `${getBaseUrl()}/customer/logout`

export const getAddTeamPath = (): string => `${getBaseUrl()}/account/#/add-team`

export const getTimelineLegacyPath = (): string => `${getBaseUrl()}/console/#/my-time/:date`
